export default {
  step: state => state.step,
  visitedStep: state => state.visitedStep,
  scanproConfiguration: state => state.scanproConfiguration,
  scanProChecklist: state => state.scanProChecklist,
  scanProCriteria: state => state.scanProCriteria,
  criteriaChanged: state => state.criteriaChanged,
  vin: state => state.vin,
  decodedVin: state => state.decodedVin,
  isDecoded: state => state.isDecoded,
  isSubmodelSelected: state => state.isSubmodelSelected,
  submodels: state => state.submodels,
  vehicle: state => state.vehicle,
  recommendation: state => state.recommendation,
  safety: state => state.safety,
  selectedChecklistItems: state => state.selectedChecklistItems,
  isLoading: state => state.isLoading,
  corporateId: state => state.corporateId
}



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/getters.js